<template>
  <div class="container">
    <div class="extracted_title">
      <span v-text="$t('utils.extractedData')" />
      <BaseButtonIcon
        color="primary"
        icon="$mdiContentSave"
        size="24"
        @click="save"
      />
    </div>
    <BaseButton
      block
      :loading="extractingData"
      class="mb-3"
      @click="extractFileData"
    >
      <span v-text="$t('utils.analyze')" />
    </BaseButton>
    <div v-for="(docValue, docKey) in form.value.metadata" :key="docKey">
      <div
        v-for="(item, itemKey) in docValue"
        :key="`${docKey}${itemKey}`"
        class="doc_item"
      >
        <div class="doc_name">
          <span>{{ $t(`utils.${docKey.toLocaleUpperCase()}`) }}</span>
          <BaseButtonIcon
            v-if="docValue.length > 1"
            color="primary"
            icon="$mdiClose"
            size="24"
            @click="removeMetadata(docKey, itemKey)"
          />
        </div>

        <div
          v-for="(dataValue, dataKey) in item"
          :key="`${dataKey}${itemKey}`"
          class="extracted_item"
        >
          <div
            v-if="
              docValue.length <= 1 ||
              form.value.metadata[docKey][itemKey][dataKey] !== ''
            "
            class="label"
            v-text="
              $t(
                `WIZIDEE_FIELD_MAPPING.${docKey.toLocaleUpperCase()}.${dataKey.toLocaleUpperCase()}`
              )
            "
          />
          <base-text-field
            v-if="docValue.length <= 1"
            v-model="form.value.metadata[docKey][itemKey][dataKey]"
            class="response"
          />
          <span
            v-if="docValue.length > 1"
            class="response"
            v-text="form.value.metadata[docKey][itemKey][dataKey]"
          />
        </div>
      </div>
    </div>

    <FolderConfirmExtractFileData
      :is-open="confirmAnalyze"
      @validate="
        confirmAnalyze = false;
        $emit('extractFileData');
      "
      @close="confirmAnalyze = false"
    />
  </div>
</template>

<script>
import FolderConfirmExtractFileData from "./FolderConfirmExtractFileData.vue";
import folderApi from "../Services/folder.api";

export default {
  name: "QuestionFileMetadataEditor",
  components: {
    FolderConfirmExtractFileData,
  },
  props: {
    workflow: {
      type: Number,
      required: true,
    },
    status: {
      type: Object,
      required: true,
    },
    question: {
      type: Object,
      required: true,
    },
    file: {
      type: Object,
      default: null,
    },
    extractingData: {
      type: Boolean,
    },
  },
  data() {
    return {
      confirmAnalyze: false,
      form: {
        value: {},
      },
    };
  },
  watch: {
    file(newFile) {
      this.form.value = newFile || {};
    },
  },
  methods: {
    removeMetadata(docKey, itemIdx) {
      this.form.value.metadata[docKey].splice(itemIdx, 1);
    },
    async save() {
      try {
        await folderApi.putOrganizationFolderStatusQuestionAnswerMetadata(
          this.$route.params.organizationId,
          this.$route.params.folderId,
          this.status.id,
          this.question.id,
          this.question.answer.id,
          this.file.id,
          this.form.value.metadata
        );
        await this.$store.dispatch("workflow/fetchFolderQuestions", {
          organizationId: this.$route.params.organizationId,
          workflowId: this.workflow,
          folderId: this.$route.params.folderId,
          statusId: this.status.id,
        });
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.snackbar.editSuccess"),
          type: "SUCCESS",
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.snackbar.editError"),
          type: "ERROR",
        });
      }
    },
    extractFileData() {
      this.confirmAnalyze = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #fff;
    border-radius: 3px;
    border: 1px solid #eeeef7;
  }

  &::-webkit-scrollbar-thumb {
    background: #b6bdff;
    border-radius: 3px;
  }
}

.extracted_title {
  color: #353542;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  margin-bottom: 10px;
}

.doc_item {
  background-color: #f4f7ff;
  margin-bottom: 12px;
  padding: 12px;

  .doc_name {
    display: flex;
    flex-direction: row;
    align-items: center;

    color: #707080;
    font-family: Inter;
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom: 10px;

    span {
      flex-grow: 1;
    }
  }
}
.extracted_item {
  .label {
    color: #707080;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
    margin-bottom: 6px;
  }
  .response {
    color: #353542;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
  }
  .response_img {
    width: 100%;
    height: auto;
    img {
      width: 100%;
      object-fit: contain;
    }
  }
  a {
    color: #2536cc;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
